import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useFriendlyName } from 'conversations-thread-data/friendly-names/public/hooks';
import { updateFriendlyNames } from 'conversations-thread-data/friendly-names/public/actions';
export const useLiveFriendlyName = ({
  messageId,
  shouldFetch,
  threadId
}) => {
  const {
    data: newFriendlyNames,
    startPolling,
    stopPolling
  } = useFriendlyName({
    messageId: messageId || '',
    useQueryOptions: {
      skip: !shouldFetch
    }
  });
  useEffect(() => {
    if (shouldFetch) {
      startPolling(200);
    }
    setTimeout(stopPolling, 60 * 1000);
  }, [shouldFetch, startPolling, stopPolling]);
  useEffect(() => {
    if (newFriendlyNames) {
      stopPolling();
    }
  }, [newFriendlyNames, stopPolling]);
  const dispatch = useDispatch();
  useEffect(() => {
    if (newFriendlyNames && newFriendlyNames.length) {
      dispatch(updateFriendlyNames({
        newFriendlyNames,
        threadId
      }));
      stopPolling();
    }
  }, [newFriendlyNames, threadId, dispatch, stopPolling]);
};